<template>
    <div
        v-if="userHasPermission && purchasedCount !== null && purchasedCount > 0"
        class="sidebar__section premium-section"
    >
        <h3>Premium</h3>
        <div
            class="usage"
            data-test-id="license-usage"
        >
            <p>License Usage:</p>
            <p>
                <span data-test-id="licenses-used">{{ usedCount }}</span
                >&sol;<span data-test-id="licenses-purchased">{{ purchasedCount }}</span>
            </p>
        </div>
        <ul>
            <li>
                <router-link
                    id="nav_premium_users"
                    tag="a"
                    :to="`/${organizationSlug}/premium-users`"
                >
                    Premium Users
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import Permissions from '@/mixins/permissions'

export default {
    name: 'PremiumNavSection',

    mixins: [needsOrganizationSlug, Permissions],

    computed: {
        ...mapGetters('licenseStats', ['purchasedCount', 'usedCount', 'userHasPermission']),
    },
}
</script>

<style scoped lang="scss">
.premium-section {
    & div {
        margin-bottom: 20px;
    }
}

div.usage {
    color: #a5a4a4;
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
    letter-spacing: 1.04px;
    text-transform: capitalize;
}
</style>
